/**
 * Click-to-Call API class
 * Handles initiating calls to customers
 */

import { BaseApi } from './base.api';
import { INTEGRATIONS_API_BASE_URL } from '@/config';
import type {
    ClickToCallRequest,
    ClickToCallResponse,
} from '@/types/clickToCall.types';

export class ClickToCallApi extends BaseApi {
    constructor() {
        super(INTEGRATIONS_API_BASE_URL);
    }

    /**
     * Initiate a click-to-call to a customer
     * Endpoint: POST /click_to_call
     */
    async clickToCall(
        request: ClickToCallRequest
    ): Promise<ClickToCallResponse> {
        try {
            const response = await this.post<ClickToCallResponse>(
                '/click_to_call',
                request,
                true
            );

            if (response.success && response.data) {
                return response.data;
            }

            return {
                message: response.message || 'Failed to initiate call',
            };
        } catch (error) {
            const apiError = this.handleError(error);
            return {
                message: apiError.message || 'Failed to initiate call. Please try again.',
            };
        }
    }
}

// Singleton instance
export const clickToCallApi = new ClickToCallApi();
